import React, { useEffect, useState } from "react";
import { Select } from "antd";
import Loader from "./Loader";
import { getAllStoreTypeForSelect } from "pages/Components/API_Modal";
import { HttpStatus } from "modules/core";
import notistack from "modules/core/notistack";
import { useDispatch } from "react-redux";
import { AppDispatch } from "slices/app/store/store";
import { fetchDashboardStats } from "slices/dashboard/dashboardSlice";

interface StoreOption {
  text: string;
  value: string;
  disabled: boolean;
  selected: boolean;
  isMayaveStore?: boolean;
}

const StoreChangeSelectComponent: React.FC = () => {
  const [storeOptions, setStoreOptions] = useState<StoreOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedStore, setSelectedStore] = useState<string | undefined>(undefined);
  const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
  const dispatch = useDispatch<AppDispatch>();

  const isMayaveStore = localStorage.getItem("isMayaveStore")
  const roleName = localStorage.getItem("roleName")

  const HasPermission = (permission: string): boolean =>
    permissionDetails.includes(permission);

  useEffect(() => {
    getAllStoreData();

    try {
      const authUserString = localStorage.getItem("authPOSUser");
      const storedStoreId = localStorage.getItem("storedataid");

      if (authUserString) {
        const authUser = JSON.parse(authUserString);
        setPermissionDetails(authUser?.permissions || []);

        if (storedStoreId) {
          setSelectedStore(storedStoreId);
        }
      }
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
    }
  }, []);
  const [selectedStoreId, setSelectedStoreId] = useState<string | null>(null);
  const getAllStoreData = async () => {
    try {
      let storeList;
      const response = await getAllStoreTypeForSelect();
      if (response?.status === HttpStatus.Success) {
        storeList = response?.data || [];
        setStoreOptions(storeList);
      }
      else {
        notistack.notifyFromApi(response)
      }

      let storedStoreId = localStorage.getItem("storeId");
      let matchedStore;

      if (storedStoreId) {
        matchedStore = storeList.find((store: any) => store.value === storedStoreId);
      }

      if (!matchedStore && storeList.length > 0) {
        matchedStore = storeList[0];
        storedStoreId = matchedStore.value;
        localStorage.setItem("storeId", storedStoreId as string);
      }

      if (matchedStore) {
        // setSelectedStore(matchedStore.value);

        if (typeof matchedStore.isMayaveStore === "boolean") {
          localStorage.setItem("isMayaveStore", JSON.stringify(matchedStore.isMayaveStore));
        } else {
          localStorage.removeItem("isMayaveStore");
        }
      }

    } catch (error) {
      console.error("Error fetching store:", error);
    }
  };


  const handleStoreChange = (value: string) => {
    // setSelectedStore(value);
    localStorage.setItem("storedataid", value);



    const selected = storeOptions.find((store) => store.value === value);

    if (selected && typeof selected.isMayaveStore === "boolean") {
      localStorage.setItem('mayavePurityEdit', JSON.stringify(selected.isMayaveStore))
      localStorage.setItem("isMayaveStore", JSON.stringify(selected.isMayaveStore));
    } else {
      localStorage.removeItem("isMayaveStore");
      localStorage.removeItem("mayavePurityEdit");
    }

    setLoading(true);
    setSelectedStoreId(value);



  };

  useEffect(() => {
    if (!selectedStoreId) return;

    const loadStats = async () => {
      try {
        await dispatch(fetchDashboardStats());

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error("Failed to load stats:", error);
      }
    };

    loadStats();
  }, [selectedStoreId, dispatch]);


  const isMainStore = localStorage.getItem('isMainStore')

  return (
    <>
      {loading && <Loader />}

      {isMainStore === 'true' && (
        <Select
          showSearch
          placeholder="Select Store"
          optionFilterProp="label"
          value={selectedStore}
          onChange={handleStoreChange}
          options={storeOptions.map((store) => ({
            label: store.text,
            value: store.value,
            disabled: store.disabled,
          }))}
          style={{ width: "15em" }}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          getPopupContainer={(trigger) => trigger.parentElement}
        />
      )}

    </>
  );
};

export default StoreChangeSelectComponent;
